export default __webpack_public_path__ + "static/media/PUR.76431bd3.svg";